export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isUuid = (value: unknown): value is string =>
  typeof value === 'string' && UUID_REGEX.test(value.trim());

export const normalizeTenantId = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
    return null;
  }

  return isUuid(trimmed) ? trimmed : null;
};

export interface TenantStorage {
  getTenantId(): Promise<string | null>;
  setTenantId(id: string): Promise<void>;
  clearTenantId(): Promise<void>;
}
